/**
 * 获取长连接地址
 */

import * as UA from '@umu/umu-ua';

export function getSocketUrl() {
    let socketUrl = '';




    socketUrl = 'wss://uim.umu.co:8095/sub';

    // socketUrl = `ws://52.80.31.35:8090/sub`;
    socketUrl = `wss://uim.umucdn.cn:8090/sub`;
    if (UA.isSandbox) {
        socketUrl = `wss://uim.umucdn.cn:8090/sub`;
    }
    return socketUrl;
}
